<template>
  <span v-if="cert">
    <v-btn icon @click="dialog = true">
      <v-icon v-if="createNew">add</v-icon>
      <v-icon v-else>edit</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" v-if="dialog" max-width="900px">
      <v-form @submit.prevent="saveCertificate" :disabled="$attrs.disabled">
        <v-card>
          <v-card-title class="headline" v-if="createNew">
            New Certificate
          </v-card-title>
          <v-card-title class="headline" v-else>
            Edit Certificate
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-layout wrap justify-space-around>
                <v-flex xs8>
                  <cert-type-select v-model="cert.certificatetypeid" />
                </v-flex>
                <v-flex xs4>
                  <v-switch
                    v-model="cert.active"
                    label="Currently Active Certificate?"
                    hint="The system will use the 'active' certificate when printing certs from the online portal, as well as when checking compliance."
                    persistent-hint
                  />
                </v-flex>

                <v-flex xs6 v-if="!cert">
                  <scope-select v-model="cert.scopeofpracticeid" />
                </v-flex>
                <v-flex xs6>
                  <v-menu
                    v-model="StartDateShowPicker"
                    :close-on-content-click="false"
                    full-width
                    max-width="290"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="cert.startdate | formatDate"
                        label="Start Date"
                        readonly
                        :rules="[rules.dates]"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :value="formattedStartDate"
                      @input="cert.startdate = $event"
                      @change="StartDateShowPicker = false"
                    />
                  </v-menu>
                </v-flex>

                <v-flex xs6>
                  <v-menu
                    v-model="ExpiryDateShowPicker"
                    :close-on-content-click="false"
                    full-width
                    max-width="290"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="cert.expirydate | formatDate"
                        label="Expiry Date"
                        readonly
                        :rules="[rules.dates]"
                        v-on="on"
                      ></v-text-field>
                    </template>

                    <v-date-picker
                      :value="formattedExpiryDate"
                      @input="cert.expirydate = $event"
                      @change="ExpiryDateShowPicker = false"
                    />
                  </v-menu>
                </v-flex>

                <v-flex xs12>
                  <payment-select
                    :value="cert.practicingcertificateid"
                    :personid="usepersonid"
                    @input="linkToPaymentId = $event"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <div class="" v-if="!createNew">
              <span class="caption italics">
                Created: {{ cert.createdby }}
                {{ cert.datecreated | formatDate }} | Updated:
                {{ cert.updatedby }} {{ cert.dateupdated | formatDate }}
                <br />
                <small>
                  <em> CertID: (#{{ cert.practicingcertificateid }}) </em>
                </small>
              </span>
            </div>
            <v-spacer></v-spacer>
            <v-fade-transition transition="fade">
              <error-messages :errors="errors" />
              <v-icon v-show="success">check</v-icon>
            </v-fade-transition>
            <v-btn
              color=" primary"
              type="submit"
              :disabled="loading || $attrs.disabled"
            >
              <v-progress-circular indeterminate v-show="loading" />
              <span v-show="!loading">Save</span>
            </v-btn>
            <v-btn @click="dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </span>
</template>

<script>
import moment from "moment";
import certTypeSelect from "./cert-type-select";
import PaymentSelect from "../payments/payment-select";
import ScopeSelect from "../register/scopes/scope-select";

export default {
  name: "certEditButton",
  data() {
    return {
      dialog: false,
      debugData: "",
      StartDateShowPicker: false,
      ExpiryDateShowPicker: false,
      linkToPaymentId: null,
      loading: false,
      errors: [],
      success: false,
      rules: {
        dates: (theDate) => {
          return (
            this.cert.expirydate == undefined ||
            this.cert.startdate == undefined ||
            moment(this.cert.startdate).isBefore(this.cert.expirydate) ||
            "Certificate must start before expiry date"
          );
        },
      },
    };
  },
  props: {
    cert: {
      type: Object,
      required: false,
      default: function () {
        return {
          personid: null,
          startdate: moment().toISOString(),
          expirydate: moment("01 Apr", "DD MMM").add(1, "year").toISOString(),
          practicingcertificateid: null,
          certificatetypeid: null,
          active: true,
        };
      },
    },
    personid: {
      type: [Number, String],
      required: false,
    },
    createNew: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedStartDate() {
      console.log("formattedStartDate");
      try {
        if (this.cert && this.cert.startdate) {
          let string = this.cert.startdate.slice(0, 10);
          console.log(string);
          return string;
        } else return "";
      } catch (e) {
        console.error(e);
      }
      return "";
    },
    formattedExpiryDate() {
      if (this.cert && this.cert.expirydate) {
        return this.cert.expirydate.slice(0, 10);
      } else return "";
    },
    usepersonid() {
      if (this.createNew) {
        return this.personid;
      } else {
        return this.cert.personid;
      }
    },
  },
  methods: {
    async saveCertificate() {
      this.loading = true;
      this.success = false;
      try {
        if (!this.createNew) {
          var result = await this.$http.patch(
            `/practicingcertificates/${this.cert.practicingcertificateid}`,
            this.cert
          );
        } else {
          this.cert.personid = this.personid;
          var result = await this.$http.post(
            `/practicingcertificates/`,
            this.cert
          );
        }

        if (result) {
          this.cert = { ...result.data };
          // this.dialog = false;
          this.success = true;
          this.createNew = false;
          this.errors = [];
          this.$emit("save", this.cert);
        }
      } catch (e) {
        this.handleError(e);
      }
      this.loading = false;
    },
    handleError(e) {
      this.errors.push(e.message);
    },
  },
  components: {
    "cert-type-select": certTypeSelect,
    "payment-select": PaymentSelect,
    "scope-select": ScopeSelect,
  },
  // created() {
  //   if (this.createNew) {
  //     this.cert = {
  //       personid: this.personid,
  //       startdate: moment().toISOString(),
  //       expirydate: moment("01 Apr", "DD MMM")
  //         .add(1, "year")
  //         .toISOString(),
  //       practicingcertificateid: null
  //     };
  //   }
  // }
};
</script>

<style></style>
